import React, {useState} from 'react';
import {Box, Grid, Typography} from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import '@fontsource/roboto';
import ApiConnectionsOptionsForm from './options/ApiConnectionsOptionsForm';
import ApiConnectionsTable from './components/ApiConnectionsTable';

const ApiConnections = () => {
    const [data, setData] = useState([]);

    return (
        <div>
            <Grid container spacing={2}
                  sx={{
                      padding: 2,
                      backgroundColor: 'white',
                      borderRadius: '8px',
                      border: '4px',
                      paddingLeft: 0,
                      paddingTop: 0,
                      marginLeft: '-10px',
                      marginTop: '-5px',
                      boxShadow: '0 0 10px rgba(0, 0, 0, 0.08)',
                  }}
            >
                <Grid item xs={12} md={12} sx={{width: '100%'}}>
                    <Accordion sx={{width: '100%'}}>
                        <AccordionSummary
                            expandIcon={<InfoOutlinedIcon/>}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                            sx={{
                                backgroundColor: '#f0f3f5',
                                width: '100%',
                                height: '35px !important',
                                minHeight: '25px !important',
                            }}
                        >
                            Explanations
                        </AccordionSummary>
                        <AccordionDetails sx={{width: '100%'}}>
                            <Box>
                                <Typography variant="subtitle1" sx={{marginBottom: '1rem'}}>
                                    API connections between companies and partner APIs.
                                </Typography>
                                <Typography variant="body1" sx={{marginLeft: '1rem'}}>
                                    Edit base URL, credentials, extra settings and enabled status. Tokens and other credentials are shown when they exist.
                                </Typography>
                            </Box>
                        </AccordionDetails>
                    </Accordion>
                </Grid>
            </Grid>

            <Grid container spacing={2}
                  sx={{
                      padding: 2,
                      backgroundColor: 'white',
                      borderRadius: '8px',
                      border: '4px',
                      paddingLeft: 0,
                      marginLeft: '-10px',
                      boxShadow: '0 0 10px rgba(0, 0, 0, 0.08)',
                      marginTop: '20px',
                  }}
            >
                <Grid item xs={12} md={12} sx={{width: '100%'}}>
                    <ApiConnectionsOptionsForm onGenerate={setData}/>
                </Grid>
                <Grid item xs={12} md={12}>
                    <ApiConnectionsTable data={data} onReload={setData}/>
                </Grid>
            </Grid>
        </div>
    );
};

export default ApiConnections;
